import {Component, OnInit, ViewChild} from '@angular/core';
import {UtilsService} from '../../../appSharedModule/services/utils.service';
import {PopService} from '../../../services/pop.service';
import {TableService} from '../../../services/table.service';
import {PopTrigramFilterCriteria} from '../../../models/filter/pop-trigram-filter-criteria';
import {Column} from '../../../share/models/column';
import * as _ from 'lodash';
import {OverlayPanel} from 'primeng/overlaypanel';
import {AuthenticationService} from '../../../authenticationModule/services/authentication.service';
import {CommercialPop} from '../../../models/commercialPop';
import {BaseClientComponent} from '../../base-client.component';
import {TechnicalPopService} from '../../../services/technical-pop.service';
import {SortEvent} from 'primeng/api'; // ADDED: to type the custom sort
import {Table} from 'primeng/table';

@Component({
  selector: 'app-pop-trigram',
  templateUrl: './pop-trigram.component.html',
  styleUrls: ['./pop-trigram.component.scss']
})
export class PopTrigramComponent extends BaseClientComponent implements OnInit {

  @ViewChild('dt') dataTable: Table;
  cols: Column[];
  commercialPopList: CommercialPop[];
  commercialPopFilteredList: CommercialPop[];
  selectedTab = 'Pop list';
  loadError = false;
  displayMessage: string;
  popTrigramFilterCriteria: PopTrigramFilterCriteria;
  userChoicesFiltersDefaultCommercialPops = {
    name: '',
    displayId: '',
    continent: '',
    bwService: false,
    qedService: false,
    qrdService: false,
    qfdService: false,
    qhfService: false,
    newsService: false
  };

  userChoicesActiveFilters = _.clone(this.userChoicesFiltersDefaultCommercialPops);
  bwServiceTechnicalPops: string[] = [];
  mdServiceTechnicalPops: string[] = [];
  rowGroupMetadata: { [continent: string]: { index: number; size: number } } = {};

  constructor(protected popService: PopService,
              public tableService: TableService,
              private authService: AuthenticationService,
              protected utilsService: UtilsService,
              protected technicalPopService: TechnicalPopService) {
    super();
  }

  private initializeColumns() {
    this.cols = [
      {field: 'commercialPop', header: 'Commercial POP', type: 'string', sortable: true},
      {field: 'technicalSiteNames', header: 'Technical Sites', type: 'string', sortable: true},
      {field: 'bwService', header: 'Bandwidth', type: 'string', sortable: false},
      {field: 'qedService', header: 'Snapshot (QED)', type: 'string', sortable: false},
      {field: 'qrdService', header: 'Raw (QRD)', type: 'string', sortable: false},
      {field: 'qfdService', header: 'Signals (QFD)', type: 'string', sortable: false},
      {field: 'qhfService', header: 'Signals (QHF)', type: 'string', sortable: false},
      {field: 'newsService', header: 'News', type: 'string', sortable: false},
      {field: 'address', header: 'Address', type: 'string', sortable: true},
      {field: 'continent', header: 'Continent', type: 'string', sortable: true},
    ];
  }

  ngOnInit() {
    this.utilsService.lockUi();
    this.initializeColumns();
    this.userChoicesActiveFilters = this.utilsService.loadUserPref('commercialPopsFilter', this.userChoicesFiltersDefaultCommercialPops);
    this.popTrigramFilterCriteria = new PopTrigramFilterCriteria(this.userChoicesActiveFilters);
    const response$ = this.authService.waitForAuthenticationThenLaunch(() => {
      this.getTrigramPops();
    });
    this.subscriptions.push(response$);

  }

  private getTrigramPops() {
    this.popService.getCommercialPops().subscribe({
      next: response => {
        response.map(pop => {
          pop.address = this.getPopAddress(pop);
          pop.commercialPop = pop.displayId + ' - ' + pop.name;
        });
        this.commercialPopList = response.filter(pop => pop.service !== '');
        this.commercialPopFilteredList = response.filter(pop => pop.service !== '');
        this.addTechnicalSitesService();
        this.sortByContinentThenField('displayId', 1);
        this.updateRowGroupMetaData();
        this.filterTable();
        this.utilsService.unlockUi();
        setTimeout(() => {
          this.displayMessage = 'Select pop from the card';
        }, 1000);
      },
      error: () => {
        this.loadError = true;
        this.utilsService.unlockUi();
      }
    });
  }

  private getPopAddress(pop: CommercialPop) {
    return [pop.street, pop.city, pop.state, pop.country].filter(Boolean).join(', ');
  }

  private addTechnicalSitesService() {
    for (const pop of this.commercialPopList) {
      pop.bwService = this.isInString(pop.service, 'bw');
      pop.qedService = this.isInString(pop.service, 'qed');
      pop.qrdService = this.isInString(pop.service, 'qrd');
      pop.qfdService = this.isInString(pop.service, 'qfd');
      pop.qhfService = this.isInString(pop.service, 'qhf');
      pop.newsService = this.isInString(pop.service, 'news');
      pop.technicalSiteNames = (pop.technicalPop.length !== 0) ? pop.technicalPop.map(tPop => tPop.technicalId).join(',') : '';
    }
  }

  getIsMckayUser() {
    return this.authService.userCurrent.permissions.isMckayUser;
  }

  exportCsv() {
    this.commercialPopFilteredList.forEach(pop => {
      pop.cageNames = pop.technicalPop
        .map(tPop => this.technicalPopService.getCageName(tPop.technicalId))
        .filter(cageName => !!cageName)
        .join(' | ');
    });
    const exportColumns = [...this.cols];
    const technicalSitesIndex = exportColumns.findIndex(col => col.field === 'technicalSiteNames');
    exportColumns.splice(technicalSitesIndex + 1, 0,
      {field: 'cageNames', header: 'Cages', type: 'string', sortable: false});
    this.dataTable.columns = exportColumns;
    this.dataTable.exportCSV();
    this.dataTable.columns = this.cols;
  }

  filter(pop: CommercialPop): boolean {
    this.utilsService.saveUserData('commercialPopsFilter',
      {
        'name': this.popTrigramFilterCriteria.name,
        'displayId': this.popTrigramFilterCriteria.displayId,
        'continent': this.popTrigramFilterCriteria.continent,
        'bwService': this.popTrigramFilterCriteria.bwService,
        'qedService': this.popTrigramFilterCriteria.qedService,
        'qrdService': this.popTrigramFilterCriteria.qrdService,
        'qfdService': this.popTrigramFilterCriteria.qfdService,
        'qhfService': this.popTrigramFilterCriteria.qhfService,
        'newsService': this.popTrigramFilterCriteria.newsService
      });
    return (this.isInString(pop.commercialPop, this.popTrigramFilterCriteria.name)
      && this.isInString(pop.displayId, this.popTrigramFilterCriteria.displayId)
      && this.isInString(pop.continent, this.popTrigramFilterCriteria.continent)
      && ((!this.popTrigramFilterCriteria.bwService && !this.popTrigramFilterCriteria.qedService && !this.popTrigramFilterCriteria.qrdService
          && !this.popTrigramFilterCriteria.qfdService && !this.popTrigramFilterCriteria.qhfService && !this.popTrigramFilterCriteria.newsService)
        || (this.popTrigramFilterCriteria.bwService && this.popTrigramFilterCriteria.bwService === pop.bwService)
        || (this.popTrigramFilterCriteria.qedService && this.popTrigramFilterCriteria.qedService === pop.qedService)
        || (this.popTrigramFilterCriteria.qfdService && this.popTrigramFilterCriteria.qfdService === pop.qfdService)
        || (this.popTrigramFilterCriteria.qhfService && this.popTrigramFilterCriteria.qhfService === pop.qhfService)
        || (this.popTrigramFilterCriteria.newsService && this.popTrigramFilterCriteria.newsService === pop.newsService)
        || (this.popTrigramFilterCriteria.qrdService && this.popTrigramFilterCriteria.qrdService === pop.qrdService)));
  }

  filterTable() {
    this.commercialPopFilteredList = [];
    for (const pop of this.commercialPopList) {
      if (this.filter(pop)) {
        this.commercialPopFilteredList.push(pop);
      }
    }
    this.sortByContinentThenField('displayId', 1);
    this.updateRowGroupMetaData();
  }

  changeSelectedTab(selectedTab) {
    this.selectedTab = selectedTab;
  }

  isInString(originalString: string, searchString: string): boolean {
    if (!searchString && !originalString) {
      return true;
    }
    if (searchString && !originalString) {
      return false;
    }
    return originalString.toLowerCase().includes(searchString.toLowerCase());
  }

  displayBwPopUp(event: MouseEvent, overlayPanel: OverlayPanel, commercialPopName) {
    this.bwServiceTechnicalPops = [];
    this.popService.getBwServiceTechnicalPops(commercialPopName).subscribe(res => {
      this.bwServiceTechnicalPops = res;
    });
    overlayPanel.toggle(event);
  }

  displayMdPopUp(event: MouseEvent, overlayPanel: OverlayPanel, commercialPopName, service) {
    this.mdServiceTechnicalPops = [];
    this.popService.getMdServiceTechnicalPops(commercialPopName, service).subscribe(res => {
      this.mdServiceTechnicalPops = res;
    });
    overlayPanel.toggle(event);
  }

  private compareContinent(v1: any, v2: any, order: number = 1): number {
    const a = (v1 ?? '').toString().trim();
    const b = (v2 ?? '').toString().trim();
    const aEmpty = a.length === 0;
    const bEmpty = b.length === 0;
    if (aEmpty && bEmpty) {
      return 0;
    }
    if (aEmpty) {
      return 1;
    }
    if (bEmpty) {
      return -1;
    }
    return this.compare(a, b, order);
  }

  private compare(v1: any, v2: any, order: number = 1): number {
    const a = (v1 ?? '').toString();
    const b = (v2 ?? '').toString();
    const res = a.localeCompare(b, undefined, {numeric: true, sensitivity: 'base'});
    return res * order;
  }

  private sortByContinentThenField(field: string, order: number) {
    if (!this.commercialPopFilteredList) {
      return;
    }
    this.commercialPopFilteredList.sort((a: any, b: any) => {
      const byContinent = this.compareContinent(a.continent, b.continent, 1);
      if (byContinent !== 0) {
        return byContinent;
      }
      const av = (a as any)[field];
      const bv = (b as any)[field];
      const byField = this.compare(av, bv, order);
      if (byField !== 0) {
        return byField;
      }
      return this.compare(a.displayId, b.displayId, 1);
    });
  }

  private updateRowGroupMetaData() {
    this.rowGroupMetadata = {};
    if (!this.commercialPopFilteredList || this.commercialPopFilteredList.length === 0) {
      return;
    }
    for (let i = 0; i < this.commercialPopFilteredList.length; i++) {
      const pop = this.commercialPopFilteredList[i];
      const continent = pop.continent || '';
      if (i === 0) {
        this.rowGroupMetadata[continent] = {index: 0, size: 1};
      } else {
        const previousRowData = this.commercialPopFilteredList[i - 1];
        const previousContinent = previousRowData.continent || '';
        if (continent === previousContinent) {
          this.rowGroupMetadata[continent].size++;
        } else {
          this.rowGroupMetadata[continent] = {index: i, size: 1};
        }
      }
    }
  }

  groupedSort(event: SortEvent) {
    if (!event || !event.data) {
      return;
    }

    const field = event.field;
    const order = event.order ?? 1;

    if (field === 'continent') {
      event.data.sort((a: any, b: any) => {
        const byContinent = this.compareContinent(a.continent, b.continent, order);
        if (byContinent !== 0) {
          return byContinent;
        }
        return this.compare(a.displayId, b.displayId, 1);
      });
    } else {
      event.data.sort((a: any, b: any) => {
        const byContinent = this.compareContinent(a.continent, b.continent, 1);
        if (byContinent !== 0) {
          return byContinent;
        }
        const av = (a as any)[field];
        const bv = (b as any)[field];
        const byField = this.compare(av, bv, order);
        if (byField !== 0) {
          return byField;
        }
        return this.compare(a.displayId, b.displayId, 1);
      });
    }
    this.updateRowGroupMetaData();
  }
}
